// extracted by mini-css-extract-plugin
export default {"faq-button":"faq-button_faq-button__RlcfD"};